<template>
  <div
    class="flex border-2 justify-center items-center rounded duration-100 cursor-pointer"
    :class="[
      value === null && !hovered ? 'border-bordergrey' : '',
      value === null && hovered
        ? 'bg-offwhite border-primary mobile:bg-white'
        : '',
      value === true && !hovered ? 'bg-primary border-primary' : '',
      value === true && hovered ? 'bg-danger border-danger' : '',
      value === false && !hovered ? 'bg-white border-danger/50' : '',
      value === false && hovered ? 'bg-white border-bordergrey' : '',
      `h-${size} w-${size}`,
    ]"
    @click.stop.prevent="toggle"
    @mouseenter="hovered = true"
    @mouseleave="hovered = false"
  >
    <span
      class="typcn text-xl leading-none"
      :class="[
        value === true ? `text-white typcn-${icon}` : '',
        value === null && hovered ? `text-primary typcn-${icon}` : '',
        value === null && !hovered ? `text-bordergrey` : '',
        value === false && !hovered ? `text-danger typcn-${iconReverse}` : '',
        value === false && hovered ? `typcn-${iconReverse}` : '',
      ]"
    />
  </div>
</template>

<script>
export default {
  name: "CustomToggleCheckbox",
  props: {
    value: {
      type: [Boolean, null],
      default: null,
    },
    size: {
      type: String,
      default: "8",
    },
    icon: {
      type: String,
      default: "tick",
    },
    iconReverse: {
      type: String,
      default: "times",
    },
  },
  data() {
    return {
      hovered: false,
    };
  },
  methods: {
    toggle() {
      if (this.value === null) this.$emit("input", true);
      else if (this.value) this.$emit("input", false);
      else this.$emit("input", null);
    },
  },
};
</script>

<style scoped lang="scss"></style>
